import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import { useTheme } from "@mui/styles";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import useTranslation from "../../hooks/useTranslation";

const useStyles = (theme) => ({
  icon: {
    p: "5px",
    height: "14px",
    width: "14px",
    borderRadius: "58px",
    bgcolor: theme.palette.white.main,
    color: theme.palette.red.main,
    ml: "3px",
  },
  button: {
    borderRadius: "100px",
    padding: "1rem",
    color: theme.palette.white.main,
    backgroundImage: "linear-gradient(99deg, #f32c4d, #d00e2e)",
    fontSize: { md: "16px", lg: "17px", xl: "18px" },
    lineHeight: { md: "30px", lg: "31px", xl: "32.4px" },
    minHeight: { md: "56px", lg: "60px", xl: "64px" },
    width: { md: "230px" },
    margin: "3rem 0 3rem 0",
    textTransform: "none",
    "&:hover": {
      color: theme.palette.white.main,
      backgroundImage: "linear-gradient(99deg, #f32c4d, #d00e2e)",
    },
  },
});

const AdmissionProcessButton = ({ xlMt, mdMt, lgMt }) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const navigate = useNavigate();
  const handleRedirect = () => {
    navigate("/aplica");
    window.scrollTo(0, 0);
  };
  const { pathname } = useLocation();
  const { title } = useTranslation(pathname, "AdmissionProcessButton");

  return (
    <Button
      endIcon={<ArrowForwardIosIcon sx={classes.icon} />}
      variant="contained"
      sx={classes.button}
      onClick={handleRedirect}
    >
      {title}
    </Button>
  );
};

export default AdmissionProcessButton;
